var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTileLayout)?_c('BookingListGroupSkeleton',{attrs:{"rows":_vm.count}}):_c('BookingCardListSkeletonLoader',{attrs:{"count":_vm.count}})}
var staticRenderFns = []

export { render, staticRenderFns }